import type { FC, SVGProps } from 'react'

import { ReactComponent as OaksIcon } from '../img/3 Oaks Gaming.svg'
import { ReactComponent as BoomingIcon } from '../img/Booming Games.svg'
import { ReactComponent as EvolutionIcon } from '../img/Evolution.svg'
import { ReactComponent as HacksawIcon } from '../img/Hacksaw.svg'
import { ReactComponent as MascotIcon } from '../img/Mascot Gaming.svg'
import { ReactComponent as NetentIcon } from '../img/Netent.svg'
import { ReactComponent as PascalIcon } from '../img/Pascal Gaming.svg'
import { ReactComponent as PlaysonIcon } from '../img/Playson.svg'
import { ReactComponent as PgIcon } from '../img/Pocket Games Soft.svg'
import { ReactComponent as PragmaticIcon } from '../img/PragmaticPlay.svg'
import { ReactComponent as RelaxIcon } from '../img/Relax Gaming.svg'
import { ReactComponent as SpribeIcon } from '../img/Spribe.svg'
import { ReactComponent as WazdanIcon } from '../img/Wazdan.svg'
import { ReactComponent as YggdrasilIcon } from '../img/Yggdrasil.svg'

export const FOOTER_PROVIDER_ICONS: { id: string; Icon: FC<SVGProps<SVGSVGElement>> }[] = [
  { id: 'evolution', Icon: EvolutionIcon },
  { id: 'pragmatic', Icon: PragmaticIcon },
  { id: 'spribe', Icon: SpribeIcon },
  { id: 'oaks', Icon: OaksIcon },
  { id: 'mascot', Icon: MascotIcon },
  { id: 'pascal', Icon: PascalIcon },
  { id: 'yggdrasil', Icon: YggdrasilIcon },
  { id: 'hacksaw', Icon: HacksawIcon },
  { id: 'booming', Icon: BoomingIcon },
  { id: 'relax', Icon: RelaxIcon },
  { id: 'netent', Icon: NetentIcon },
  { id: 'playson', Icon: PlaysonIcon },
  { id: 'wazdan', Icon: WazdanIcon },
  { id: 'pg', Icon: PgIcon },
]
